import { DOCUMENT, inject, Injectable } from '@angular/core';
import { Observable, fromEvent } from 'rxjs';
import { map } from 'rxjs/operators';

function getFullScreenAPIComponent(document: any, apiComponentArray: any) {
  let finalAPIComponent;
  apiComponentArray.forEach((apiComponent: any) => {
    if (document[apiComponent]) {
      finalAPIComponent = apiComponent;
    }
  });
  return finalAPIComponent;
}

const fullScreenVendorAPI = {
  request: ['requestFullScreen', 'mozRequestFullScreen', 'webkitRequestFullscreen', 'msRequestFullscreen'],
  cancel: ['cancelFullScreen', 'exitFullscreen', 'mozCancelFullScreen', 'webkitExitFullscreen', 'msExitFullscreen'],
};

@Injectable()
export class FullscreenService {
  private readonly document = inject(DOCUMENT);

  private polyfill: any = {
    request: getFullScreenAPIComponent(this.document.documentElement, fullScreenVendorAPI.request),
    cancel: getFullScreenAPIComponent(this.document, fullScreenVendorAPI.cancel),
  };
  /**
   * Event emitter which emits an array with the original Event and the
   * HTMLElement which is currently shown fullscreen. If fullscreen is off
   * @return {Observable}
   */
  public change$: Observable<{
    event: Event;
    element?: HTMLElement;
    isFullscreen: boolean;
  }>;

  constructor() {
    // setup event listener for fullscreen change
    let eventName: string = '';
    if ('onwebkitfullscreenchange' in this.document) {
      eventName = 'webkitfullscreenchange';
    } else if ('onfullscreenchange' in this.document) {
      eventName = 'fullscreenchange';
    } else if ('onmozfullscreenchange' in this.document) {
      eventName = 'mozfullscreenchange';
    } else if ('onmsfullscreenchange' in this.document) {
      eventName = 'msfullscreenchange';
    }
    this.change$ = fromEvent(this.document, eventName).pipe(
      map((event: any) => {
        const element = (this.document['fullscreenElement'] ||
          this.document['mozFullScreenElement'] ||
          this.document['webkitFullscreenElement'] ||
          this.document['msFullscreenElement']) as HTMLElement;

        const isFullscreen = !!element;
        return { event, element, isFullscreen };
      })
    );
  }

  /**
   * Request fullscreen mode for the given DOM element
   *
   * @param nativeElement
   */
  public request(nativeElement: any) {
    nativeElement[this.polyfill.request]();
  }

  public cancel() {
    (this.document as any)[this.polyfill.cancel]();
  }

  public isSupported() {
    return this.polyfill.request;
  }
}
